import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography, useMediaQuery, useTheme} from '@mui/material';

import {CultureAnalysisEmptyState} from '../CultureAnalysisEmptyState/CultureAnalysisEmptyState';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {EmployeeFeedback} from '../../types/EmployeeFeedbackTypes';

interface EmployeeFeedbackCardsProps {
  employeeFeedback: EmployeeFeedback | undefined;
}

export default function EmployeeFeedbackCards({employeeFeedback}: EmployeeFeedbackCardsProps) {
  const theme = useTheme();
  const {t} = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const paperStyles: SxProps = {
    padding: '8px 16px',
    backgroundColor: 'white',
    border: `1px solid ${orangeColors[3]}`,
    boxShadow: 'none',
    borderRadius: '0px 16px 16px 16px',
    width: '100%',
    flexBasis: {xs: '100%', md: '30%'},
  };

  const hasFeedback = Boolean(employeeFeedback?.length);

  const renderFeedbackCards = () => {
    return employeeFeedback?.map((feedback, index) => (
      <Box key={index} sx={paperStyles} data-testid='feedback-card'>
        <Typography variant='body1' sx={{color: greenColors[700]}}>
          {feedback}
        </Typography>
      </Box>
    ));
  };

  return (
    <Grid container flexDirection={'column'}>
      <Grid item mt={12}>
        <Typography variant={isSmallScreen ? 'h2' : 'h1'} sx={{color: greenColors[700]}}>
          {t('companyCultureDashboard.employeeFeedback.sectionTitle')}
        </Typography>
      </Grid>
      <Grid item mt={5} mb={2}>
        <Typography variant={isSmallScreen ? 'h3' : 'h2'} sx={{color: greenColors[700]}}>
          {t('companyCultureDashboard.employeeFeedback.feedback')}
        </Typography>
      </Grid>
      <Grid
        item
        container
        gap={4}
        display={'grid'}
        gridTemplateColumns={{xs: '1fr', md: 'repeat(3, minmax(min-content, 1fr))'}}
      >
        {hasFeedback ? (
          renderFeedbackCards()
        ) : (
          <Grid item xs={12}>
            <CultureAnalysisEmptyState message={t('companyCultureDashboard.employeeFeedback.emptyState')} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
